'use strict';
import './structure/adjustVh';
import './structure/adjustViewport';

import NavEvent from './components/NavEvent';
import InViewEvent from './components/inViewEvent';
import VoiceSlider from './components/VoiceSlider';

document.addEventListener('DOMContentLoaded', () => {
  console.log('Hello toumei');
  const navEvent = new NavEvent();
  const inViewEvent = new InViewEvent();
  const voiceSlider = new VoiceSlider();
});
